class BackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    setTimeout(() => {
      this.listeners.add(document, 'click', this.handleTrigger)

      this.els?.close?.elements.forEach((closeEl) => {
        this.listeners.add(closeEl, 'click', this.handleClose)
      })

      this.externalEls?.close?.elements.forEach((closeEl) => {
        this.listeners.add(closeEl, 'click', this.handleClose)
      })
    }, 500)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-back-in-stock-external-el="trigger"]',
    )

    if (!trigger) return

    this.externalEls.modal.element.showModal()

    document.dispatchEvent(new CustomEvent('back-in-stock-open'))

    await window.BAO.sectionRenderer
      .fetchSingle('back-in-stock', trigger.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')

        this.els.content.element.innerHTML = myself.innerHTML
      })
      .catch(() => {})
  }

  handleClose () {
    this.externalEls.modal.element.close()
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
